/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/tr.js'



import {QCarousel,QCarouselSlide,QCarouselControl,QInput,Dialog,Notify,Meta} from 'quasar'



export default { config: {},lang,components: {QCarousel,QCarouselSlide,QCarouselControl,QInput},plugins: {Dialog,Notify,Meta} }

